import { render, staticRenderFns } from "./RefundDetail.vue?vue&type=template&id=f21d7f12&scoped=true"
import script from "./RefundDetail.vue?vue&type=script&lang=js"
export * from "./RefundDetail.vue?vue&type=script&lang=js"
import style0 from "./RefundDetail.vue?vue&type=style&index=0&id=f21d7f12&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f21d7f12",
  null
  
)

export default component.exports